<template>
    <div class="container-diario">

        <!-- <div class="u-mb-10" style="display: flex; background-color: #fff; padding: 20px;">
            <div style="flex: 1; align-items: center; display: flex; justify-content: space-around;">
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <img style="width: 130px; margin: 10px 0;" src="/public/img/google-play.png" />
                    <img style="width: 130px; margin: 10px 0;" src="/public/img/app-store.png" />
                </div>
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <img style="width: 130px; margin: 10px 0;" src="/public/img/mobile.png" />
                </div>
            </div>
            <div style="flex: 1; justify-content: center; align-items: center; display: flex;">
                <img src="/public/img/seta.png" />
            </div>
            <div style="flex: 2; display: flex; flex-direction: column;">
                <div>
                    <h3>Olá, usuários</h3>
                    <p>
                        A partir de agora, o diário de classe será totalmente digital. A frequência, o lançamento de notas, 
                        a gestão das atividades de classe e muito mais serão realizados digitalmente por meio de um navegador 
                        com acesso à internet ou offline, por meio de um smartphone (Android ou iOS).
                    </p>
                </div>
                <div style="display: flex; justify-content: space-around;">
                    <div>
                        <h2>Diário Eletrônico</h2>
                        <ul style="padding-left: 10px;">
                            <li>✅ Registro de frequência</li>
                            <li>✅ Lançamento de notas</li>
                            <li>✅ Cadastro de atividades</li>
                        </ul>
                    </div>
                    <div>
                        <h2>Portal do Aluno</h2>
                        <ul style="padding-left: 10px;">
                            <li>✅ Visualização das notas</li>
                            <li>✅ Visualização da frequência</li>
                            <li>✅ Interação online entre instituição e alunos/responsáveis</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->

        <c-panel>
            
            <el-form label-position="top" class="u-mb-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingTurmas" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item key="periodo">
                            <el-select @change="loadingTurmas" v-model="filtro.periodo_id">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="20" :md="20">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingAlunos" v-model="filtro.turma_id" filterable placeholder="Turma">
                                <el-option-group
                                    v-for="(grupo, i) in turmas"
                                    :key="i"
                                    label="">
                                <el-option
                                    v-for="turma in grupo"
                                    :key="turma.id"
                                    :label="`${turma.curso.nome} ${turma.nome}`"
                                    :value="turma.id">
                                </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
            </el-form>
            <div class="u-mb-10">
                <!-- <i>Anteção: É possível alterar a data de matrícula e transferência clicando sobre a data.</i> -->
                <!-- <el-button v-if="filtro.turma_id" @click="openDialogConteudo(filtro.turma_id)" title="Mais ações" size="mini" style="float: right; width: 120px;" plain>
                    <i class="fas fa-edit"></i>
                    Conteúdo
                </el-button> -->
                <el-button v-if="filtro.turma_id" @click="imprimirBoletins()" title="Imprimir todos os boletins da turma" size="mini" style="float: right; margin-right: 8px; margin-bottom: 10px;" plain>
                    <i class="fas fa-print"></i>
                    Imprimir Boletins em Lote
                </el-button>
            </div>
            <div class="">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 90px;">Nº Matrícula</th>
                            <th>Nome</th>
                            <!-- <th class="u-text-center">Data Matrícula</th>
                            <th class="u-text-center">Data Transferência</th> -->
                            <th style="width: 300px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <tr v-for="item in alunos" :key="item.id">
                            <td>{{ item.num_matricula }}</td>
                            <td>
                                <a @click="openDossieAluno(item)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                    <b class="hidden-desktop">NOME:</b> {{ item.aluno.nome_social_aluno ? item.aluno.nome + ' – ' + item.aluno.nome_social_aluno : item.aluno.nome }}<br>
                                </a>
                                <span v-if="item.aluno.mae" class="nm-mae">Filiação 1: {{ item.aluno.mae.toLowerCase() }}</span>
                            </td>
                            <!-- <td class="u-text-center">
                                <a href="javascript:void(0)" @click="abreAlteraData(item, 'matricula')">
                                    {{ item.data_matricula ? $moment(item.data_matricula).format('DD/MM/YYYY') : '---' }}
                                </a>
                           </td>
                            <td class="u-text-center">
                                <a href="javascript:void(0)" @click="abreAlteraData(item, 'transferencia')">
                                    {{ item.data_transferencia ? $moment(item.data_transferencia).format('DD/MM/YYYY') : '---' }}
                                </a>
                            </td> -->
                            <td class="u-text-center acao"> 
                                <el-button @click="openDialogFrequencia(item)" title="Mais ações" size="mini" style="width: 120px;" plain>
                                    <i class="far fa-calendar-alt"></i>
                                    Frequência
                                </el-button>
                                <el-button @click="openDialogNota(item.aluno)" title="Mais ações" size="mini" style="width: 120px;" plain>
                                    <i class="fas fa-calculator"></i>
                                    Notas
                                </el-button>   
                                <el-popover placement="left">
                                    <ul class="list-acoes">                                        
                                        <li @click="openDialogPrintBoletim(item)">
                                            <i class="fas fa-calculator"></i>
                                            Imprimir boletim
                                        </li>
                                    </ul>
                                    <el-button slot="reference" title="Mais ações"  icon="el-icon-menu" size="mini" plain style="margin-left: 10px;"></el-button>
                                </el-popover>                         
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <div v-if="loading" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
        </c-panel>
        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoSelected.aluno.id" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" :title="alunoSelected ? `${ alunoSelected.nome_social_aluno ? alunoSelected.nome_social_aluno +' – '+ alunoSelected.nome : alunoSelected.nome } - ${$moment(alunoSelected.data_nascimento).format('DD/MM/YYYY')}` : ''" :visible.sync="dialogFrequencia">
            <div v-if="dialogFrequencia" style="margin-top: 20px;">
                <frequencia :turma_id="filtro.turma_id" :aluno_id="alunoSelected.id" :tipo_ensino="alunoSelected.tipo_ensino" :mostra_gerenciar_freq="true" @close="closeDialogFrequencia"></frequencia>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" :title="alunoSelected ? `${alunoSelected.nome_social_aluno ? alunoSelected.nome_social_aluno +' – '+ alunoSelected.nome : alunoSelected.nome } - ${$moment(alunoSelected.data_nascimento).format('DD/MM/YYYY')}` : ''" :visible.sync="dialogNota">
            <div v-if="dialogNota" style="margin-top: 20px;">
                <nota :turma_id="filtro.turma_id" :aluno_id="alunoSelected.id" :mostra_gerenciar_nota="true" @close="closeDialogNota"></nota>
            </div>
        </el-dialog>
        
        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" title="Conteúdo" :visible.sync="dialogConteudo">
            <div v-if="dialogConteudo" style="margin-top: 20px;">
                <conteudo :turma_id="filtro.turma_id" @close="closeDialogConteudo"></conteudo>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" :title="`ALTERAR DATA - ${matriculaSelected.aluno ? matriculaSelected.aluno.nome : ''}`" width="40%" :visible.sync="dialogAlterarData" v-on:close="closeDialogAlterarData">
            <div v-if="dialogAlterarData" style="margin-top: 20px;">
                
                <el-form @submit.native.prevent="onSubmitAlterarData" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="24" :md="24">
                            <el-form-item :label="`Data ${alteraData.tipo == 'matricula' ? 'de Matrícula' : 'da Transferência'}`" key="data" prop="data">                
                                <el-input v-model="alteraData.data" v-mask="'##/##/####'"></el-input>
                            </el-form-item>                        
                        </el-col>                   
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="40%" :title="`BOLETIM ESCOLAR - ${alunoSelected['nome_aluno']}`" :visible.sync="dialogPrintBoletim">
            <div v-if="dialogPrintBoletim" style="margin-top: 20px; padding: 20px 50px;">
                <el-row :gutter="10">
                    <el-col :xs="12" :sm="24" :md="24">
                        <p class="u-text-center">As versõe de PDF e Word estão disponíveis para impressão do boletim escolar.</p>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="margin-top: 30px;">
                    <el-col :xs="12" :sm="12" :md="12">
                        <div class="u-text-center">
                            <img @click="printBoletimEscolar('pdf')" src="/public/img/file-pdf.png" style="width: 120px;" class="u-pointer"/>    
                        </div>                  
                    </el-col>         
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-center">
                            <img @click="printBoletimEscolar('word')" src="/public/img/doc.png" style="width: 120px;" class="u-pointer"/>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="margin-top: 30px;">
                    <el-col :xs="12" :sm="24" :md="24">
                        <p class="u-text-center">Selecione uma das opções acima.</p>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

    </div>
</template>
<script>

import dossieAluno from '@/components/aluno/dossie'
import frequencia from '@/components/diario/frequencia/info'
import nota from '@/components/diario/nota/info'
import conteudo from '@/components/diario/conteudo/info'

export default {
    data: () => ({
        loading: false,
        dialogAlterarData: false,
        alteraData: {
            turma_id: '',
            aluno_nome: '',
            aluno_id: '',
            data: '',
            tipo: ''
        },
        matriculaSelected: {},
        dialogDossieAluno: false,
        dialogFrequencia: false,
        dialogNota: false,
        dialogConteudo: false,
        dialogPrintBoletim: false,
        alunoSelected: {},
        filtro: {
            instituicao_id: '',
            periodo_id: '',
            turma_id: ''
        },
        turmas: [],
        alunos: [ ]
    }),
    mounted () {

        this.filtro.periodo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if(this.$store.state.config.instituicao){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            this.loadingTurmas();
        }
    },
    methods: { 
        abreAlteraData(item, tipo) {

            if(tipo == 'matricula') {

                this.alteraData.data = item.data_matricula ? this.$moment(item.data_matricula).format('DD/MM/YYYY') : '';
            } else {
                this.alteraData.data = item.data_transferencia ? this.$moment(item.data_transferencia).format('DD/MM/YYYY') : '';
            }

            this.matriculaSelected = item;
            this.alteraData.tipo = tipo;
            this.alteraData.turma_id = this.filtro.turma_id;
            this.alteraData.aluno_id = item.aluno_id;
            this.alteraData.aluno_nome = item.nome_aluno;
            this.dialogAlterarData = true;
            
        },
        async onSubmitAlterarData() {

            if(this.alteraData.tipo == 'matricula' && !this.alteraData.data) {

                window.eventBus.$emit('alert', {msg: 'É necessário informar uma data para a matrícula.', type: 'warning'});
                return;
            }
            
            window.eventBus.$emit('loading', true);

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/updateData`, this.alteraData, this.$store.getters.getHeaderAuth);

            if(typeof response.data.erro !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

            }else{

                this.dialogAlterarData = false;
                window.eventBus.$emit('loading', false);
                this.loadingAlunos();
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
            }

        },
        closeDialogAlterarData() {

            this.matriculaSelected = {};
            this.alteraData = {
                turma_id: '',
                aluno_nome: '',
                aluno_id: '',
                data: '',
                tipo: ''
            };
        },
        imprimirBoletins(){
            if(!this.filtro.turma_id) return;
            window.eventBus.$emit('print', { url: '/api/nota/print-boletim-escola-turma/pdf', param: { turma_id: this.filtro.turma_id } });
        },
        openDialogConteudo(turma_id){

            this.dialogConteudo = true;
        },
        closeDialogConteudo(){
            
            this.dialogConteudo = false;
        },
        openDossieAluno(item){

            this.dialogDossieAluno = true;
            this.alunoSelected = item;

        },
        openDialogFrequencia(item){
            this.alunoSelected = { tipo_ensino: item.tipo_ensino, ...item.aluno };
            this.dialogFrequencia = true;   
        },
        closeDialogFrequencia(){
            this.dialogFrequencia = false;
        },
        openDialogNota(item){
            this.alunoSelected = item;
            this.dialogNota = true;
        },      
        openDialogPrintBoletim(item){
            this.alunoSelected = item;
            this.dialogPrintBoletim = true;
        } ,
        closeDialogNota(){
            this.dialogNota = false;
        },
        closeDialogDossieAluno(){

            this.alunoSelected = {  };
            this.dialogDossieAluno = false;
        },
        loadingTurmas(){

            this.alunos = [];
            this.filtro.turma_id = '';

            if(!this.filtro.instituicao_id || !this.filtro.periodo_id) {
                return;
            }            

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;                

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        loadingAlunos(){

            this.alunos = [];

            if(!this.filtro.turma_id) {
                return;
            }            

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForDiario/${this.filtro.turma_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.alunos = response.data;                

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        changeDossie(actions){

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
        printBoletimEscolar(format) {

            if(format == 'pdf') {
                window.eventBus.$emit('print', {url: '/api/nota/print-boletim-escola', param: {aluno_id: this.alunoSelected.aluno_id, turma_id: this.alunoSelected.turma_id, format: 'pdf' }});
            }

            if(format == 'word') {

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/print-boletim-escola`, {param: {aluno_id: this.alunoSelected.aluno_id, turma_id: this.alunoSelected.turma_id, format: 'word' }}, this.$store.getters.getHeaderAuthExcel).then(response => {

                    this.loadingButtonExcel = false;

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'boletim-escolar.docx');
                    document.body.appendChild(link);
                    link.click();

                }).catch((error) => { this.$store.commit('throwException', error); });
                
            }
        }
    },

    components:{ dossieAluno, frequencia, nota, conteudo }
}
</script>
<style>
    .container-diario .level {
        
        border-radius: 30px !important;
        border: 2px solid #b1b1b1;

    }
    .container-diario .info {
        
        width: 100% !important;
        text-align: center !important;
    }

    .container-diario .info img {
        max-width: 200px;
    }

    .icon-edit-data {
        color: #999999;
        margin-left: 5px;
    }

</style>